<template>
    <form class="-client-add"
          v-on:submit.prevent="submit"
          action="">
        <div class="form-group">
            <label for="clients-add-moral-person-name">Nom de la structure</label>
            <input type="text"
                   id="clients-add-moral-person-name"
                   v-model="name"
                   required
                   class="form-control">
        </div>

        <div>
            <div class="form-group">
                <label for="clients-add-moral-person-address">Adresse</label>
                <input-address :input-class="'form-control'"
                               input-id="clients-add-moral-person-address"
                               placeholder="Saisir puis choisir une adresse"
                               :address.sync="address"
                               required></input-address>
            </div>
        </div>

        <hr>

        <h3>Contact</h3>

        <person-form :data.sync="data"
                     :id-suffix="'-moral-person'"></person-form>

        <div class="row">
            <div class="col-sm-12 cta">
                <button type="submit" class="btn btn-primary -add-moral-person">
                    Créer
                </button>
            </div>
        </div>
    </form>
</template>

<script type="text/ecmascript-6">
    import PersonForm from './PersonForm';
    import InputAddress from '../../components/form/InputAddress';
    import {dataToContact, makeDefaultData} from './utils';

    export default {
        components: {
            InputAddress,
            PersonForm
        },
        data() {
            return {
                data: makeDefaultData(),
                address: {},
                name: ''
            };
        },
        computed: {
            clientData() {
                return {
                    name: this.name,
                    type: 'moral',
                    address: JSON.stringify(this.address),
                    status: 'prospect',
                    contacts: [dataToContact(this.data)]
                };
            }
        },
        methods: {
            submit() {
                this.$dispatch('clients:add', this.clientData);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// AddMoralPerson.vue?70717ce4